import { DELIVERY_PRICING, DELIVERY_PRICING_ADD_LOCATION, DELIVERY_PRICING_UPLOAD } from "../../constants/urls";
import { RouteObject } from "react-router-dom";

export default [
  {
    path: DELIVERY_PRICING,
    lazy: () => import("./routes/DeliveryPricingOverview"),
  },
  {
    path: DELIVERY_PRICING_UPLOAD,
    lazy: () => import("./routes/DeliveryPricingUpload"),
  },
  {
    path: DELIVERY_PRICING_ADD_LOCATION,
    lazy: () => import("./routes/DeliveryPricingAddLocation"),
  },
] as RouteObject[];
